import React, { useState } from 'react';
import { ButtonNew, FlexBox, ModalNew, Typography, Box } from '@helloworld1812/ws-components';
import { useHistory } from 'react-router-dom';
import { useHasFunctionModule } from '@helloworld1812/ws-biz-hooks';
import { useUsersMeCached } from '@helloworld1812/hr-api';
import { IconCalendarNew, IconUserEntity } from '@helloworld1812/ws-icons';
import { useTranslation } from 'react-i18next';

import { useHrMutation } from '@/api';
import { HiringPaywallWrapper } from '@/components/tier-lite';

import fromWizardModalIcon from '../../assets/from-wizard-modal.svg';

import { OnboardingStep } from './user-onboarding-page.const';

export function UserOnboardingWelcomeModal() {
  const history = useHistory();
  const { t } = useTranslation('hr-account-routes');
  const { user, refetch } = useUsersMeCached();
  const onboardingStep = user.user_onboarding_desktop_step as OnboardingStep;
  const isSuperAdmin = user.is_super_admin;
  const [visible, setVisible] = useState(!isSuperAdmin && onboardingStep === 'welcome_modal');

  const { mutateAsync: goToNextOnboardingStep } = useHrMutation({
    url: '/v1/users/next_onboarding_step',
    method: 'post',
  });

  const finishWelcomeModal = async () => {
    setVisible(false);
    await goToNextOnboardingStep({
      data: {
        user_onboarding_desktop_step: 'welcome_modal',
      },
    });
    refetch();
  };
  const hasSchedulingModule = useHasFunctionModule('scheduling');

  if (!visible) {
    return null;
  }

  return (
    <ModalNew
      title={t('Welcome to Workstream')}
      variant="quick-action"
      visible={visible}
      width={700}
      footer={null}
      onClose={finishWelcomeModal}
      onCancel={finishWelcomeModal}
      headerBorder
    >
      <FlexBox pt={16} pb={32} gap={3}>
        <Box>
          <img src={fromWizardModalIcon} alt={t('Man hugging a profile file item')} />
        </Box>
        <FlexBox column justify="center" gap={20} width="60%" shrink={0}>
          <Typography variant="h1" fontSize={22}>
            {t("What's next?")}
          </Typography>
          <FlexBox flexDirection="row" gap={8}>
            <HiringPaywallWrapper hasNoFunctionModule="scheduling" mode="hover">
              <ButtonNew
                variant="secondary"
                icon={<IconCalendarNew size={20} />}
                size="compact"
                disabled={!hasSchedulingModule}
                onClick={() => {
                  finishWelcomeModal();
                  history.push('/schedule');
                }}
              >
                {t('Set up interview schedule')}
              </ButtonNew>
            </HiringPaywallWrapper>
            <ButtonNew
              variant="secondary"
              size="compact"
              style={{ marginBottom: '5px' }}
              onClick={() => {
                finishWelcomeModal();
                history.push('/applicants/all-applicants');
              }}
              icon={<IconUserEntity size={20} />}
            >
              {t('Review applicants')}
            </ButtonNew>
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </ModalNew>
  );
}
